module.exports = require("./se-SE.d.ts");